export default class Result {
  constructor ({ data }) {
    this.data = data
  }

  get path () {
    return this.data.path
  }
}
